// import FeatureDisabled from "global/FeatureDisabled"
import * as Landing from "scenes/Landing"
import * as SearchResult from "scenes/SearchResult"
import * as Login from "scenes/Login"
import * as Tickets from "scenes/Tickets"
import React from "react"
/**
 * Map with all the public accessible features
 * @example
 * {
 *   login: {
 *     enabled: true,
 *     reducer,
 *     actions,
 *     types,
 *     selectors,
 *     pages: {
 *       Login: LoginPage
 *     }
 *   },
 *   ...
 * }
 */
// TODO probably try https://github.com/tdeekens/flopflip
// Or https://vasanthk.gitbooks.io/react-bits/patterns/29.feature-flags-using-redux.html
const features = {}

const CALL_DISABLED_FEATURE = "equipenine/CALL_DISABLE_FEATURE"

const overrideValues = (object, newValue) => {
  const newObject = {}
  for (const key in object) {
    newObject[key] = newValue
  }
  return newObject
}

const FeatureDisabled = ({ name }) => (
  <div>
    <h4>You have no access</h4>
    <div>Try to go home and ask support to get access to this feature.</div>
  </div>
)

/**
 * Function for plugin creation
 */
const registerFeature = ({
  name,
  enabled,
  reducer,
  actions,
  types,
  selectors,
  pages,
  ...rest
}) => {
  if (!name) {
    throw new Error("Feature name is missing")
  }
  if (name in features) {
    throw new Error(`Feature with name ${name} already exists`)
  }

  if (enabled) {
    features[name] = {
      enabled,
      reducer,
      actions,
      types,
      selectors,
      pages,
      ...rest
    }
  } else {
    // Override feature stuff to not do everything if it is not enabled
    const feature = {
      enabled,
      // selectors always have to be public cause of failures in isPending
      selectors
    }
    if (reducer && typeof reducer === "function") {
      feature.reducer = () => ({})
    }
    if (actions && typeof actions === "object") {
      feature.actions = overrideValues(actions, () => {
        return {
          type: CALL_DISABLED_FEATURE
        }
      })
    }
    if (pages && typeof pages === "object") {
      feature.pages = overrideValues(pages, FeatureDisabled)
      // feature.pages = overrideValues(pages)
    }
    features[name] = feature
  }
}

registerFeature({
  name: "landing",
  enabled: true,
  ...Landing
})
registerFeature({
  name: "searchResult",
  enabled: true,
  ...SearchResult
})
registerFeature({
  name: "login",
  enabled: true,
  ...Login
})
registerFeature({
  name: "tickets",
  enabled: true,
  ...Tickets
})

export default features
